<template>
  <div>
    <div v-if="!isDashLoading">
      <v-row no-gutters class="question-topbar">
      <v-col cols="6">
        <div class="questions-title">Drivers/subdrivers analysis</div>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-menu offset-y offset-overflow max-width="400">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="box-container zoom-in ml-1 mr-4"
            >
              <v-icon small class="mr-2">las la-cloud-download-alt</v-icon>
              <span>Export report</span>
            </v-btn>
          </template>
          <v-list three-line>
            <v-list-item @click="downloadReport('withfilter')">
              <v-list-item-avatar>
                <i class="las la-filter"></i>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>Currently filtered</v-list-item-title>
                <v-list-item-subtitle>
                  Export report of all data
                  that are currently shown in the
                  table on the page.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="downloadReport()">
              <v-list-item-avatar>
                <i class="las la-user-friends"></i>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>All data</v-list-item-title>
                <v-list-item-subtitle>
                  Export the list of all data
                  that are present.
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          color="white"
          class="box-container zoom-in"
          @click.stop="toggleReportFilter"
        >
          <i class="las la-filter mr-1"></i>
          <span>Filter</span>
        </v-btn>
        <v-btn
          class="box-container zoom-in ml-2"
          v-if="isFilterApplied"
          @click="resetFilter()"
        >
          <i class="las la-sync-alt"></i>
        </v-btn>
      </v-col>
    </v-row>
      <v-row class="driver-engagement-overview">
        <v-col cols="1" class="driver-icon">
          <!-- <i class="las la-tachometer-alt"></i> -->
          <i class="lar la-life-ring"></i>
        </v-col>
        <v-col cols="11">
          <div class="driver-heading-sub">Drivers measure how satisfied employees are with the culture, leadership, work life balance and responsibilities that make up their experience at work.</div>
        </v-col>
      </v-row>
      <v-row class="driver-engagement-wrap">
        <v-col
          v-for="(driver, key) in interactionDrivers"
          :key="key"
          cols="4"
        >
          <div class="driver-card-wrap box-container">
            <div class="driver-header">
              <div class="driver-stats">
                <v-progress-circular
                  :rotate="270"
                  :size="60"
                  :width="8"
                  :value="driver.average*2*10"
                  color="primary"
                >
                  <span class="driver-score" v-if="driver.average">
                    {{driver.average}}
                  </span>
                  <span class="driver-score" v-else>
                    --
                  </span>
                </v-progress-circular>
              </div>
              <div class="driver-title">
                {{key.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}
              </div>
            </div>
            <div class="driver-body">
              <v-row
                v-for="(subdriver, k) in driver.sub_drivers"
                :key="k"
                class="subdriver-row"
                @click="viewSubdriver(key, k)"
              >
                <v-col cols="10">
                  <v-row no-gutters>
                    <v-col cols="1">
                      <i class="lar la-dot-circle"></i>
                    </v-col>
                    <v-col cols="11" class="pl-2">
                      {{k.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="2">
                  <div :style="`color:${getEngagementColor(subdriver)}`">
                    {{subdriver}}
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="driver-footer">
              <v-btn color="primary" outlined @click="onViewDriver(key)">View analysis</v-btn>
            </div>
          </div>
          <!-- <div class="driver-overview-wrap box-container">
            <v-row no-gutters class="driver-card-row">
              <v-col cols="2">
                <div class="driver-header">
                  <div class="driver-stats">
                    <v-progress-circular
                      :rotate="270"
                      :size="60"
                      :width="8"
                      :value="45*2"
                      color="primary"
                    >
                      <span class="driver-score">
                        4.5
                      </span>
                    </v-progress-circular>
                  </div>
                </div>
              </v-col>
              <v-col cols="10">
                <div class="driver-title">
                  {{key.replace(/([a-z0-9])([A-Z])/g, '$1 $2')}}
                </div>
              </v-col>
            </v-row>
          </div> -->
        </v-col>
      </v-row>
      <!-- <div v-if="!interactionDrivers && Object.keys(interactionDrivers).length <= 0" class="am-no-data"> -->
      <div v-if="Object.keys(this.interactionDrivers).length <= 0" style="text-align: center;padding: 10%;">
        Not enough data to generate analysis
      </div>
    </div>
    <driverEngagementFilters
      ref="driverEngagementFilters"
      @getDashboardWithFilter="filterApplied"
    ></driverEngagementFilters>
    <amara-loader
      v-if="isDashLoading"
    ></amara-loader>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
// import DriversSortbar from './common-comp/drivers-sortbar';
// import DriverSubdriverBar from './common-comp/driver-subdriver-bar';
// import DriverOverview from './common-comp/driver-overview';
// import SubdriversHeatmap from './driver-comp/subdrivers-heatmap';
// import QuestionHeatmap from './subdriver-comp/question-heatmap';
import DriverEngagementFilters from './driver-engagement-filter';
import AmaraLoader from '../elements/amara-loader';

import DriversMixin from './drivers-mixins';
import SubdriversMixin from './subdrivers-mixins';

export default {
  name: 'DriverEngagementWrap',

  mixins: [DriversMixin, SubdriversMixin],

  components: {
    // DriversSortbar,
    // DriverSubdriverBar,
    // DriverOverview,
    // SubdriversHeatmap,
    // QuestionHeatmap,
    DriverEngagementFilters,
    AmaraLoader
  },

  data () {
    return {
      interactionDrivers: {},
      activeDriver: 'Culture',
      activeSubdriver: '',
      isFilterApplied: false,
      isDashLoading: true,
      isViewLoading: true,
      showSubDriverHeatmap: true,
      sortByData: {
        business: 'Business',
        cluster: 'Cluster',
        department: 'Department',
        gender: 'Gender',
        grade: 'Grade',
        hr_manager: 'HR Manager',
        hrbp: 'HR Business Partner',
        location: 'Location',
        site: 'Site'
      },
      activeQuestion: null,
      engagementFilters: {}
    };
  },

  created () {
    // this.getDrivers();
  },

  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler () {
        if (this.$route && this.$route.query && this.$route.query.filters) {
          const updateReportFilters = JSON.parse(this.$route.query.filters);
          this.engagementFilters = updateReportFilters;
        }
      }
    }
  },

  beforeMount () {
    // console.log('this.$route.query.filtersn in drivers', this.$route.query);
    if (this.$router.currentRoute.query && this.$router.currentRoute.query.driver) {
      this.activeDriver = this.$router.currentRoute.query.driver;
    }
    // else {
    //   this.getDriverAnalysis();
    // }
  },

  computed: {
    subdriversList () {
      if (this.activeDriver && this.interactionDrivers && Object.keys(this.interactionDrivers).length > 0) {
        return this.interactionDrivers[this.activeDriver];
      }
      return [];
    },
    ...mapState({
      user: state => state.user,
      dashboardFilters: state => state.updateDriversFilters
    })
  },

  methods: {
    downloadReport (type) {
      const queryParams = {};
      if (type === 'withfilter') {
        if (this.dashboardFilters.user__profile__high_potential_emp) {
          queryParams.user__profile__high_potential_emp = true;
        }
        if (this.dashboardFilters.initiated_date_end) {
          queryParams.initiated_date_start = this.dashboardFilters.initiated_date_start;
          queryParams.initiated_date_end = this.dashboardFilters.initiated_date_end;
        }
        if (this.dashboardFilters.initiated_date_end) {
          queryParams.segment_filter = this.dashboardFilters && this.dashboardFilters.segment_filter ? this.dashboardFilters.segment_filter : undefined;
        }
        if (this.dashboardFilters && this.dashboardFilters.filters) {
          this.$lodash.each(this.dashboardFilters.filters, (v, k) => {
            if (v.length > 0 && k !== 'session__stage__title') {
              queryParams[`user__profile__${k}__in`] = v.join();
            } else {
              queryParams.stage__title__in = v.join();
            }
          });
        }
      }
      axios.get(`${process.env.VUE_APP_API_URL}reports/download_driver_analytics_excel_report?report_type=driver_engagement_breakdown`, {
        params: queryParams
      }).then((response) => {
        // console.log('response', response);
        if (response && response.data && response.data.success) {
          if (response.data.report_url) {
            this.downloadingFlag = false;
            this.$forceUpdate();
            setTimeout(() => {
              window.open(response.data.report_url);
            }, 100);
          } else {
            this.downloadingFlag = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to generate report, Please try again later!'
            });
          }
          this.reportDialog = false;
        } else {
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
          this.reportDialog = false;
        }
        this.downloadingFlag = false;
      }).catch((err) => {
        if (err.response.status === 429) {
          // this.loading = false;
          // this.open = false;
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          // this.loading = false;
          // this.open = false;
          this.downloadingFlag = false;
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to generate report, Please try again later!'
          });
        }
      });
    },
    checkPermission (permission) {
      let flag = false;
      this.$lodash.each(this.user.permissions, (perm) => {
        this.$lodash.each(permission, (v) => {
          if (v === perm) {
            flag = true;
          }
        });
      });
      return flag;
    },
    toggleReportFilter () {
      this.$refs.driverEngagementFilters.showFilterDrawer = !this.$refs.driverEngagementFilters.showFilterDrawer;
    },
    viewSubdriver (driver, subdriver) {
      const queryParams = {};
      queryParams.filters = this.$route.query && this.$route.query.filters ? this.$route.query.filters : undefined;
      queryParams.driver = driver;
      queryParams.subdriver = subdriver;
      this.$router.push({
        path: '/drivers/view/subdriver',
        query: queryParams
      }).catch(() => {});
    },
    getEngagementColor (score) {
      let color = '';
      if (score <= 3) {
        color = '#f44336';
      } else if (score <= 4) {
        color = '#ff9800';
      } else if (score <= 5) {
        color = '#37b99c';
      }
      return color;
    },
    onViewDriver (driver) {
      const queryParams = {};
      queryParams.filters = this.$route.query && this.$route.query.filters ? this.$route.query.filters : undefined;
      queryParams.driver = driver;
      this.$router.push({
        path: '/drivers/view',
        query: queryParams
      }).catch(() => {});
    },
    onClickQuestion (q) {
      // const elmnt = document.getElementById(q);
      // console.log('elmnt', elmnt);
      // elmnt.scrollIntoView();
    },
    onClickDriver (driver) {
      this.activeDriver = driver;
      this.showSubDriverHeatmap = true;
      if (this.activeSubdriver !== '' && this.$refs && this.$refs.subdriversBar) {
        this.$refs.subdriversBar.activeTab = 'overall';
      }
      this.getDriverAnalysis();
    },
    onClickSubdriver (subdriver) {
      this.activeSubdriver = subdriver;
      if (subdriver !== 'overall') {
        this.showSubDriverHeatmap = false;
        this.getSubDriverAnalysis();
      } else {
        this.showSubDriverHeatmap = true;
        this.getDriverAnalysis();
      }
    },
    onClickSortBy (sortKey) {
      // console.log('sortKey', sortKey);
      if (sortKey) {
        this.getEngagementHeatMap(sortKey);
      }
    },
    filterApplied (val) {
      this.isFilterApplied = val;
      if (this.$route && this.$route.query && this.$route.query.filters) {
        const updateReportFilters = JSON.parse(this.$route.query.filters);
        this.engagementFilters = updateReportFilters;
      }
      this.getDrivers();
    },
    // viewSubdriver (subdriver) {
    //   this.onClickSubdriver(subdriver);
    //   setTimeout(() => {
    //     const elmnt = document.getElementById('drivers-overview');
    //     if (elmnt) {
    //       // elmnt.scrollIntoView();
    //       window.scrollTo({
    //         top: 0,
    //         left: 0,
    //         behavior: 'smooth'
    //       });
    //     }
    //   }, 1000);
    // },
    // onClickSubdriverViewQuestion (val) {
    //   this.onClickSubdriver(val.subdriver);
    //   setTimeout(() => {
    //     this.onClickViewQuestion(val.question);
    //   }, 500);
    // },
    // onClickViewQuestion (q) {
    // console.log('question', q);
    // const elmnt = document.getElementById(q);
    // if (elmnt) {
    //   elmnt.scrollIntoView();
    // }
    //   setTimeout(() => {
    //     this.expandQuestion(q);
    //   }, 500);
    // },
    // resetQuestions (idx) {
    //   this.$lodash.each(this.questions, (val) => {
    //     if (val !== idx) {
    //       this.$refs[val][0].style.display = 'none';
    //       this.$refs[`acrd-${val}`][0].classList.remove('active');
    //     }
    //   });
    // },
    // expandQuestion (idx) {
    //   this.resetQuestions(idx);
    //   if (this.$refs[idx][0].style.display === 'none') {
    //     this.$refs[idx][0].style.display = 'block';
    //     this.$refs[`acrd-${idx}`][0].classList.add('active');
    //   } else {
    //     this.$refs[idx][0].style.display = 'none';
    //     this.$refs[`acrd-${idx}`][0].classList.remove('active');
    //   }
    //   const elmnt = document.getElementById(idx);
    //   if (elmnt) {
    //     elmnt.scrollIntoView(true);
    //   }
    // },
    resetFilter () {
      this.isFilterApplied = false;
      this.$refs.driverEngagementFilters.resetFilters();
      this.engagementFilters = {};
      this.getDrivers();
    },
    getDrivers () {
      this.isDashLoading = true;
      const filters = Object.assign({}, this.engagementFilters);
      if (filters && filters.filters) {
        delete filters.filters;
      }
      const queryParams = {
        segment_filter: this.engagementFilters && this.engagementFilters.segment_filter ? this.engagementFilters.segment_filter : undefined,
        ...filters
      };
      if (this.engagementFilters && this.engagementFilters.filters) {
        this.$lodash.each(this.engagementFilters.filters, (v, k) => {
          if (v.length > 0 && k !== 'session__stage__title') {
            queryParams[`user__profile__${k}__in`] = v.join();
          } else {
            queryParams.stage__title__in = v.join();
          }
        });
      }
      // console.log('interactionDrivers', this.interactionDrivers, Object.keys(this.interactionDrivers).length <= 0);
      axios.get(`${process.env.VUE_APP_API_URL}reports/driver_enagagement_breakdown`, {
        params: queryParams
      }).then((response) => {
        if (response && response.data) {
          this.interactionDrivers = response.data;
          if (this.checkPermission(['company_culture_dashboard'])) {
            this.isDashLoading = false;
          } else {
            this.isDashLoading = true;
          }
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get details, Please try again later!'
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.question-topbar {
  padding: 12px 12px;
  background: #584475;
  background: #050550;
  background-image: -webkit-gradient(linear,right top, left top,from(transparent),to(rgba(51,148,255,0.18)));
  .questions-title {
    color: var(--bg);
    display: flex;
    align-items: center;
    font-size: var(--stats-size-1);
  }
  .analytics-title-wrap {
    display: flex;
  }
}
.driver-engagement-overview {
  .driver-icon {
    text-align: center;
    i {
      font-size: 40px !important;
    }
  }
  .driver-heading {
    font-size: var(--stats-size-1);
    font-weight: var(--heading-weight);
  }
  .driver-heading-sub {
    font-size: var(--heading-size);
  }
}
.driver-engagement-wrap {
  padding: 0 12px;
  .driver-card-wrap {
    .driver-header {
      display: flex;
      padding: 16px;
      border-bottom: 1px solid rgba(0,0,0,0.1);
      .driver-title {
        padding-left: 16px;
        display: flex;
        align-items: center;
        font-size: var(--heading-size);
      }
      .driver-score {
        font-size: var(--content-size);
      }
    }
    .driver-body {
      // padding: 0px 16px 0px 64px;
      height: 13rem;
      overflow-y: auto;
      border-bottom: 1px solid rgba(0,0,0,0.1);
      .subdriver-row {
        margin: 0;
        padding: 0px 0px 0px 64px;
        &:hover {
          cursor: pointer;
          background-color:rgba(0,0,0,0.1);
        }
      }
    }
    .driver-footer {
      // background-color: #f4f3ff;
      background-color: var(--bg);
      text-align: center;
      padding: 8px;
    }
  }
  // .driver-overview-wrap {
  //   // padding: 16px;
  //   height: 12rem;
  //   .driver-card-row {
  //     height: 100%;
  //   }
  //   .driver-header {
  //     // height: 100%;
  //     display: flex;
  //     padding: 16px;
  //   }
  //   .driver-title {
  //     padding: 16px;
  //     display: flex;
  //     align-items: center;
  //     font-size: var(--heading-size);
  //     border-bottom: 1px solid rgba(0,0,0,0.1);
  //   }
  //   .driver-body {
  //     padding: 16px;
  //     height: 12rem;
  //     overflow-y: auto;
  //     border-bottom: 1px solid rgba(0,0,0,0.1);
  //   }
  //   .driver-footer {
  //     background-color: #f4f3ff;
  //     text-align: center;
  //     padding: 16px;
  //   }
  // }
}
</style>
